import * as messages from './fr'
export default messages
